import { v4 as uuidv4 } from "uuid";
import { AnyAction, Dispatch } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { db } from "../../config/firebase";
import { collection, getDocs, DocumentData, QuerySnapshot, setDoc, doc, deleteDoc } from "firebase/firestore";
import * as actionTypes from "../types/customersActionTypes";
import { Customer } from "../../components/auth/Auth";
import { toast } from "react-toastify";

export const fetchCustomersRequest = () => ({
    type: actionTypes.FETCH_CUSTOMERS_REQUEST,
});

export const fetchCustomersSuccess = (data: Customer[]) => ({
    type: actionTypes.FETCH_CUSTOMERS_SUCCESS,
    payload: data
});

export const fetchCustomersFail = (error: any) => ({
    type: actionTypes.FETCH_CUSTOMERS_FAIL,
    payload: error
});

export const fetchCustomers = () => {
    return async (dispatch: Dispatch) => {
        dispatch(fetchCustomersRequest());
        try {
            const querySnapshot: QuerySnapshot<DocumentData> = await getDocs(collection(db, "customers"));
            const customers: Customer[] = querySnapshot.docs
                .map(doc => ({ ...doc.data() as Customer }))
                .sort((a, b) => a.name.localeCompare(b.name));

            dispatch(fetchCustomersSuccess(customers));
        } catch (error) {
            console.error(error);
            dispatch(fetchCustomersFail(error));
        }
    };
};

export const addCustomerRequest = () => ({
    type: actionTypes.ADD_CUSTOMER_REQUEST,
});

export const addCustomerSuccess = () => ({
    type: actionTypes.ADD_CUSTOMER_SUCCESS
});

export const addCustomerFail = (error: any) => ({
    type: actionTypes.ADD_CUSTOMER_FAIL,
    payload: error
});

export const addCustomer = (customer: Customer | null, isAddMode: boolean) => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
        dispatch(addCustomerRequest());
        const id: string = isAddMode ? uuidv4() : customer?.id as string;

        try {
            await setDoc(doc(db, "customers", id), {
                id: id,
                address: customer?.address,
                canOrderCurrentDay: customer?.canOrderCurrentDay,
                deliveryTime: customer?.deliveryTime,
                email: customer?.email,
                identificationNumber: customer?.identificationNumber,
                name: customer?.name,
                phoneNumber: customer?.phoneNumber,
                subvention: customer?.subvention,
                taxId: customer?.taxId
            });

            dispatch(addCustomerSuccess());
            dispatch(fetchCustomers());
            toast.success(`Usprešno ste ${isAddMode ? "dodali novu " : "sačuvali "} kompaniju.`);
        } catch (error) {
            console.error(error);
            dispatch(addCustomerFail(error));
        }
    };
};

export const deleteCustomerRequest = () => ({
    type: actionTypes.DELETE_CUSTOMER_REQUEST,
});

export const deleteCustomerSuccess = () => ({
    type: actionTypes.DELETE_CUSTOMER_SUCCESS
});

export const deleteCustomerFail = (error: any) => ({
    type: actionTypes.DELETE_CUSTOMER_FAIL,
    payload: error
});

export const deleteCustomer = (customer: Customer) => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
        dispatch(deleteCustomerRequest());
        try {
            await deleteDoc(doc(db, "customers", customer.id));
            dispatch(deleteCustomerSuccess());
            dispatch(fetchCustomers());

            toast.success("Usprešno ste obrisali kompaniju.");
        } catch (error) {
            console.error(error);
            dispatch(deleteCustomerFail(error));
        }
    };
};